import React, {useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import './index.scss';

import * as Routes from '../../../constants/routes';
import * as Actions from '../../../redux/actions';

//assets
import personal_details from 'assets/icons/personal-menu-details.svg';
import payment_methods from 'assets/icons/payment-methods.svg';
import address from 'assets/icons/address.svg';
import {getMediaPath} from "../../../app/functions";

const UserDetails = (props) =>{

    const userData = useSelector(store => store.config.UserData);
    const text = useSelector(store => store.config.Translations);
    const comment = useSelector(store => store.config.UserComment);

    const dispatch = useDispatch();

    useEffect(()=>{
      return () =>{
          dispatch(Actions.updateUserComment(''));
      }
    },[]);

    const getCardDetails = () =>{
        let boxes = [];

        //personal details
        boxes.push({title:'פרטי המזמין', first: userData.first_name + ' ' + userData.last_name,
            second: userData.phone, third: userData.email, image: personal_details, link: Routes.personal_zone + Routes.personal_zone_routes.personal_details});

        //address' details
        userData.addressArr.forEach(item =>{
            if (item.default){
                boxes.push({title: 'פרטים למשלוח',first: item.street_name + ' ' + item.house_num + ', ' + item.city_name,
                    second: item.zip_code, third: 'קומה ' + item.floor_num + ' דירה ' + item.apartment,image: address,
                    link: Routes.personal_zone + Routes.personal_zone_routes.address});
            }
        });

        //card's details
        for (let key in userData.cardsArr){
            const item = userData.cardsArr[key];
            if (item.default){
                boxes.push({title: 'אמצעי תשלום',first: '(' + item.last_digits + ')',
                    second: userData.user_id, image: payment_methods, link: Routes.personal_zone + Routes.personal_zone_routes.payment_methods});
            }
        }

        let res = [];

        boxes.forEach((item, index) =>{
           res.push(
               <div key={index} className='box-wrapper'>
                   <img src={getMediaPath(item.image)} alt=''/>
                   <span className='title'>{item.title}</span>
                   <span>{item.first}</span>
                   <span>{item.second}</span>
                   <span>{item.third}</span>
                   <span className='link' onClick={()=> props.history.push(item.link)}>עריכת פרטים</span>
               </div>
           )
        });

        return res;
    };

    return(
        <section className='user-details'>
             <div className='details-container'>
                 {getCardDetails()}
             </div>
            <div className='user-comment'>
                <span>{text['payment_comments_label']}</span>
                <textarea value={comment} onChange={(e) => dispatch(Actions.updateUserComment(e.target.value))}/>
            </div>
        </section>
    )
};

export default withRouter(UserDetails);